export enum EFamilyUrls {
  BASE_URL = 'parents',
  EXPORT = 'export',
}

export const getFamilyUrl = EFamilyUrls.BASE_URL;
